/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-use-before-define */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect, useMemo } from 'react';
import {
  capitalize, isEmpty, get, map, concat, find, size, compact,
} from 'lodash';
import { connect } from 'react-redux';
import './Assets/Styles/ProviderPickStep.css';
import Badge from '@material-ui/core/Badge';
import {
  Close, Favorite, FavoriteBorder, Star, Warning,
} from '@material-ui/icons';
import Slider from 'react-slick';
import moment from 'moment';
import { favoritePro, getProReviews, getTherapistPrivateProfile, getTherapistPrublicProfile } from '../Shared/helpers';
import placeholder from './Assets/Images/placeholder.png';
import avatar from './Assets/Images/profile-avatar.svg';
import { seInboxViewMessage, seProfileViewed, seProviderContact } from '../../Shared/WebAnalytics';
import { openChat } from '../../AppointmentManagement/Shared/helpers';
import { getSingleChatState } from '../../AppointmentManagement/Shared/constants';
import { ROUTES, NOT_BEFORE_H } from '../../../constants';
import { HOST_ROOT } from '../../../apiConfig';
import { fetchChat } from '../../../Actions';
import CTAButton from '../../Shared/CTAButton';

function ComplimentsSection(compliments) {
  if (!isEmpty(compliments)) {
    return (
      <div className="mb-32">
        <div className="size-24-32 font-weight-bold contentPrimary mt-24 mb-8">Client compliments</div>
        <Slider {...{
          dots: false,
          infinite: false,
          slidesToShow: 5.5,
          swipeToSlide: true,
          arrows: false,
        }}
        >
          {compliments.map((compliment, complimentKey) => (
            <div className=" mr-24 centered" key={`complmnt-${complimentKey}`}>
              <Badge
                overlap="rectangular"
                className="xs-bdg-top centered"
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                badgeContent={compliment.total}
              >
                <img className="w-h-60 br-rd-50" src={compliment.icon_url || placeholder} alt={`${compliment.title || ''}`} />
              </Badge>
              <div className="size-10-15 contentSecondary mt-8">
                {compliment.title || ''}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
  return null;
}

function ReviewsSection(reviews, isShowMoreClicked, setIsShowMoreClicked) {
  if (!isEmpty(reviews)) {
    let tempList = isShowMoreClicked ? reviews : reviews.slice(0, 3);
    return (
      <div className="mb-24">
        <div className="size-24-32 font-weight-bold contentPrimary mt-24 mb-8">{reviews?.length} Reviews</div>
        {map(tempList, (review) => (
          <div key={`review-${review.id}`}>
            <div className="d-flex-only mt-16 mb-16">
              <div className='mr-8'>
                <img className="w-h-36 obj-fit-cover br-rd-50" src={review.avatar_url || placeholder} alt={`${review.client_name || ''}`} />
              </div>
              <div>
                <div className="size-16-20 font-weight-bold contentPrimary mb-4">{review.client_name || ''}</div>
                <div className="size-14-20 contentSecondary">{moment(review.datetime).format("MMM YYYY") || ''}</div>
              </div>
            </div>
            <div className='size-12-20 contentSecondary mb-16'>{review.body || ''}</div>
          </div>
        ))}
        {isShowMoreClicked ? null : <div className="d-flex-only justify-content-center">
          <button
            type="button"
            className="btn bg-accent-light DarkBluePrimary font-weight-bold size-16-20 p-14-16 br-rd-24"
            onClick={() => {
              setIsShowMoreClicked(!isShowMoreClicked);
            }}
          >
            {isShowMoreClicked ? 'Show less reviews' : 'Show more reviews'}
          </button>
        </div>}
      </div>
    );
  }
  return null;
}

function ProProfileDetails(props) {
  const [proProfile, setProProfile] = useState({});
  const [expanded, setExpanded] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [isShowMoreClicked, setIsShowMoreClicked] = useState(false);
  const [reviews, setReviews] = useState(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [activeTab, setActiveTab] = useState('book');
  const [defaultTimeSet, setDefaultTimeSet] = useState(false);

  const {
    pro, selectPro, unselectPro, showProDetailsToggle, time, showSendMessage,
    click_source, isPrivate, selected, hasMoreThanProSelected, market,
    backupRanges, availableTimeSlots, isIC,
  } = props;

  const isICProvider = isIC;

  // Calculate available time slots for this provider (using useMemo to compute before useEffect)
  const availableTimes = useMemo(() => {
    // Helper function to convert time string to minutes since midnight
    const timeToMinutes = (timeStr) => {
      if (!timeStr || typeof timeStr !== 'string') return null;
      const [time, period] = timeStr.split(' ');
      if (!time || !period) return null;
      let [hours, minutes] = time.split(':').map(Number);
      if (Number.isNaN(hours)) return null;
      const mins = Number.isNaN(minutes) ? 0 : minutes;
      if (period === 'PM' && hours !== 12) hours += 12;
      if (period === 'AM' && hours === 12) hours = 0;
      return hours * 60 + mins;
    };

    // Get the booking date from props
    const bookingDateStr = get(props, 'booking.cart.date.value', '');
    
    // Filter times to only allow 8:00am to 10:00pm
    const filterAllowedHours = (times) => {
      if (!times || isEmpty(times)) return times;
      
      const MIN_HOUR = 8 * 60; // 8:00am in minutes (480)
      const MAX_HOUR = 22 * 60; // 10:00pm in minutes (1320)
      
      return times.filter((timeSlot) => {
        const slotMinutes = timeToMinutes(timeSlot);
        if (slotMinutes === null) return false;
        
        // Only allow times between 8:00am and 10:00pm (inclusive)
        return slotMinutes >= MIN_HOUR && slotMinutes <= MAX_HOUR;
      });
    };
    
    // Filter times based on bookability (NOT_BEFORE_H constraint)
    const filterBookableTimes = (times) => {
      if (!times || isEmpty(times)) return times;
      
      // If no booking date, return all times
      if (!bookingDateStr) return times;
      
      const now = moment();
      const bookingDate = moment(bookingDateStr, 'YYYY-MM-DD');
      const isToday = bookingDate.isSame(now, 'day');
      
      // If booking is not today, all times are valid
      if (!isToday) return times;
      
      // For today, filter out times that are less than NOT_BEFORE_H hours from now
      const minimumBookingTime = now.clone().add(NOT_BEFORE_H, 'hours');
      
      return times.filter((timeSlot) => {
        const slotMinutes = timeToMinutes(timeSlot);
        if (slotMinutes === null) return false;
        
        // Create a moment object for this time slot on the booking date
        const slotDateTime = bookingDate.clone()
          .hours(Math.floor(slotMinutes / 60))
          .minutes(slotMinutes % 60)
          .seconds(0);
        
        // Check if slot is at least NOT_BEFORE_H hours from now
        return slotDateTime.isAfter(minimumBookingTime) || slotDateTime.isSame(minimumBookingTime);
      });
    };

    if (isICProvider) {
      // For IC providers, first filter by allowed hours (8am-10pm), then by bookability
      let filteredTimes = filterAllowedHours(availableTimeSlots || []);
      filteredTimes = filterBookableTimes(filteredTimes);
      return filteredTimes;
    }
    
    // For non-IC providers, also apply the 8am-10pm filter
    return filterAllowedHours(availableTimeSlots || []);
  }, [isICProvider, backupRanges, availableTimeSlots, props]);

  useEffect(() => {
    const getProProfile = async (proId) => {
      getTherapistPrublicProfile(proId, (response) => {
        setProProfile(response?.data?.therapist);
        setIsFavorite(get(pro, 'is_favorite', false));
        seProfileViewed(proId, get(response, 'data.therapist.rating', 0), get(response, 'data.therapist.number_of_bookings', 0), click_source, 'new_flow', market, isIC);
      }, props?.errorHandler);
    };
    const getPrivateProProfile = async (proId) => {
      getTherapistPrivateProfile(proId, (response) => {
        setProProfile(response?.data?.therapist);
        setIsFavorite(get(pro, 'is_favorite', false));
        seProfileViewed(proId, get(response, 'data.therapist.rating', 0), get(response, 'data.therapist.number_of_bookings', 0), click_source, 'new_flow', market, isIC);
      }, props?.errorHandler);
    };
    if (isPrivate) {
      pro.id && getPrivateProProfile(pro.id);
    } else {
      pro.id && getProProfile(pro.id);
    }
    if (pro.id && !reviews) {
      getProReviews(pro.id, (response) => {
        setReviews(response?.data?.reviews || []);
      }, props?.errorHandler);
    }
  }, [pro.id]);

  // Reset state when provider changes
  useEffect(() => {
    setSelectedTimeSlot(null);
    setDefaultTimeSet(false);
    setActiveTab('book');
  }, [pro.id]);

  // Set default time slot for IC providers
  useEffect(() => {
    if (isICProvider && !isEmpty(availableTimes) && !defaultTimeSet && !selectedTimeSlot) {
      // Helper function to convert time string to minutes
      const timeToMinutes = (timeStr) => {
        if (!timeStr || typeof timeStr !== 'string') return null;
        const trimmed = timeStr.trim();
        const parts = trimmed.split(' ');
        if (parts.length < 2) return null;
        const [time, period] = parts;
        const timeParts = time.split(':');
        if (timeParts.length < 2) return null;
        let [hours, minutes] = timeParts.map(Number);
        if (Number.isNaN(hours)) return null;
        const mins = Number.isNaN(minutes) ? 0 : minutes;
        const periodUpper = period.toUpperCase();
        if (periodUpper === 'PM' && hours !== 12) hours += 12;
        if (periodUpper === 'AM' && hours === 12) hours = 0;
        return hours * 60 + mins;
      };

      const preferredTimeFromCart = get(props, 'booking.cart.info_fields.preferred_time', '');

      // Priority 1: If preferred time is available, select it (compare by minutes to handle formatting differences)
      if (preferredTimeFromCart) {
        const preferredMinutes = timeToMinutes(preferredTimeFromCart);
        const exactMatchSlot = availableTimes.find((slot) => {
          const slotMinutes = timeToMinutes(slot);
          return slotMinutes !== null && preferredMinutes !== null && slotMinutes === preferredMinutes;
        });
        if (exactMatchSlot) {
          setSelectedTimeSlot(exactMatchSlot);
          setDefaultTimeSet(true);
          return;
        }
      }

      // Priority 2: If preferred time is not available, select the closest time to preferred time
      if (!isEmpty(availableTimes) && preferredTimeFromCart) {
        const preferredMinutes = timeToMinutes(preferredTimeFromCart);
        if (preferredMinutes !== null) {
          let closestSlot = availableTimes[0];
          let smallestDiff = Math.abs((timeToMinutes(closestSlot) || 0) - preferredMinutes);

          for (let i = 1; i < availableTimes.length; i += 1) {
            const slot = availableTimes[i];
            const slotMinutes = timeToMinutes(slot);
            if (slotMinutes === null) continue;
            const diff = Math.abs(slotMinutes - preferredMinutes);
            if (diff < smallestDiff) {
              smallestDiff = diff;
              closestSlot = slot;
            }
          }

          setSelectedTimeSlot(closestSlot);
          setDefaultTimeSet(true);
          return;
        }
      }

      // Priority 3: If no preferred time or unable to calculate closest, select the first available time
      if (!isEmpty(availableTimes)) {
        setSelectedTimeSlot(availableTimes[0]);
        setDefaultTimeSet(true);
      }
    }
  }, [isICProvider, availableTimes, defaultTimeSet, selectedTimeSlot, props.booking]);

  const {
    avatar_url, first_name, last_name, rating,
    bio, service_categories, number_of_bookings,
    since, compliments, public_avatar_url, private_avatar_url,
  } = proProfile;
  const displayName = `${first_name} ${get(last_name, '0', '')}.`;

  // Determine if we should show the preferred-time-unavailable banner
  // Show banner when preferred time is NOT available among provider's available times
  const showPreferredUnavailableBanner = (() => {
    if (!isICProvider) return false;
    if (isEmpty(backupRanges)) return false;
    if (isEmpty(availableTimes)) return false;

    const preferredTime = get(props, 'booking.cart.info_fields.preferred_time', '');
    if (!preferredTime) return false;
    
    // Helper to normalize time strings to minutes for comparison
    const toMinutes = (timeStr) => {
      if (!timeStr || typeof timeStr !== 'string') return null;
      const trimmed = timeStr.trim();
      const parts = trimmed.split(' ');
      if (parts.length < 2) return null;
      const [clock, period] = parts;
      const timeParts = clock.split(':');
      if (timeParts.length < 2) return null;
      let hours = parseInt(timeParts[0], 10);
      const minutes = parseInt(timeParts[1], 10) || 0;
      if (Number.isNaN(hours)) return null;
      const periodUpper = (period || '').toUpperCase();
      if (periodUpper === 'PM' && hours !== 12) hours += 12;
      if (periodUpper === 'AM' && hours === 12) hours = 0;
      return hours * 60 + minutes;
    };
    
    const preferredMinutes = toMinutes(preferredTime);
    if (preferredMinutes === null) return false;
    
    // Check if preferred time is present in available times
    const isPreferredAvailable = availableTimes.some((slot) => {
      const slotMinutes = toMinutes(slot);
      return slotMinutes !== null && slotMinutes === preferredMinutes;
    });
    
    // Show banner only if preferred time is NOT available but other times ARE available
    return !isPreferredAvailable;
  })();

  // Helper: convert 'h:mm AM/PM' to minutes since midnight
  const parseTimeToMinutes = (timeString) => {
    if (!timeString || typeof timeString !== 'string') return null;
    const parts = timeString.trim().split(' ');
    if (parts.length < 2) return null;
    const [clock, period] = parts;
    const [hStr, mStr] = clock.split(':');
    let hours = parseInt(hStr, 10);
    const minutes = parseInt(mStr, 10) || 0;
    if (Number.isNaN(hours)) return null;
    const isPm = (period || '').toUpperCase() === 'PM';
    const isAm = (period || '').toUpperCase() === 'AM';
    if (isPm && hours !== 12) hours += 12;
    if (isAm && hours === 12) hours = 0;
    return hours * 60 + minutes;
  };

  // For GA providers, pick preferred cart time or closest available
  const getPreferredOrClosestTimeForGA = () => {
    const preferredDisplayTime = get(props, 'time', '');
    const slots = Array.isArray(availableTimes) ? availableTimes : [];
    if (isEmpty(slots)) return preferredDisplayTime;
    if (preferredDisplayTime && slots.includes(preferredDisplayTime)) return preferredDisplayTime;
    const preferredMinutes = parseTimeToMinutes(preferredDisplayTime);
    if (preferredMinutes === null) return slots[0];
    let closestSlot = slots[0];
    let smallestDiff = Math.abs((parseTimeToMinutes(closestSlot) || 0) - preferredMinutes);
    for (let i = 1; i < slots.length; i += 1) {
      const slot = slots[i];
      const slotMinutes = parseTimeToMinutes(slot);
      if (slotMinutes === null) continue;
      const diff = Math.abs(slotMinutes - preferredMinutes);
      if (diff < smallestDiff) {
        smallestDiff = diff;
        closestSlot = slot;
      }
    }
    return closestSlot;
  };

  function setUnsetFav() {
    favoritePro(get(props, 'client.user_id', ''), {
      therapist_id: pro.id,
      is_favorite: !isFavorite,
    }, get(this.props, 'fieldsHolder.csrfToken', ''), () => {
      setIsFavorite(!isFavorite);
    });
  }
  function openChatWithPro(proIds) {
    openChat(compact(proIds), (resp) => {
      const crtPrds = get(resp, 'data.cart.display_helpers.v0.cart_products', []);
      props.fetchChat(get(resp, 'data', {}));
      seInboxViewMessage({
        state: getSingleChatState(get(resp, 'data.chats', [])),
        click_source: 'appointment_details',
        cart_product_count: size(crtPrds),
        booking_status: get(resp, 'data.cart.info_fields.tracker.state', 'pending'),
        is_rebook: get(resp, 'data.cart.info_fields.rebook', false),
        service_category: get(crtPrds, '0.product.title', ''),
        service_modality: get(crtPrds, '0.cart_product_main_option.title', ''),
      });
      window.location.href = `${HOST_ROOT}${ROUTES.inbox}?chat_id=${get(resp, 'data.chat_id', '')}`;
    }, (err) => {
      console.log({ err });
    });
  }

  if (first_name) {
    return (
      <div className="pro-profile-container" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="pro-profile-content-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
            <div className="p-16-24-24-24">
            <a
              className="back-to-search"
              href="&times;"
              onClick={(e) => { e.preventDefault(); showProDetailsToggle(); }}
            >
              <Close className="LightBlack size-16-24" />
            </a>
            {isPrivate
              ? (
                <button
                  type="button"
                  className="btn btn-link abs-top t-16 r-24 p-0"
                  onClick={setUnsetFav}
                >
                  {isFavorite ? <Favorite className="size-16-24 color-red" />
                    : <FavoriteBorder className="size-16-24 contentPrimary" />}
                </button>
              )
              : null}
            <div className="centered">
              <div>
                <Badge
                  overlap="rectangular"
                  color="primary"
                  className="centered-badge badge-w-46"
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  badgeContent={(
                    <div className="size-14-16 centered d-flex-only align-items-center">
                      {rating}
                      {' '}
                      <Star className="contentInversePrimary size-16-20" />
                    </div>
                  )}
                >
                  <img className="w-h-119 br-rd-50" src={private_avatar_url || avatar_url || public_avatar_url || avatar} alt="avatar" />
                </Badge>
              </div>
              <div className="size-32-40 font-weight-bold contentPrimary mt-16">{displayName}</div>
              <div className="size-16-24 contentPrimary mb-8">
                {number_of_bookings || 0}
                {' '}
                bookings
                <br />
                Joined
                {' '}
                {moment(new Date()).subtract(since?.months, 'months').format('MMM')}
                {' '}
                {moment(new Date()).subtract(since?.years, 'years').format('YYYY')}
              </div>
              {showSendMessage ? (
                <div>
                  <button
                    type="button"
                    className="btn btn-accent-light"
                    onClick={() => {
                      seProviderContact('appointment_details_page');
                      openChatWithPro([pro.id]);
                    }}
                  >
                    Send Message
                  </button>
                </div>
              ) : null}
            </div>
            
            {/* Tabs for IC providers only */}
            {isICProvider && !isEmpty(availableTimes) && (
              <div className="mt-24" style={{ width: '100%' }}>
                <div style={{ 
                  display: 'flex', 
                  borderBottom: '1px solid #E2E2E2',
                  width: '100%',
                  position: 'relative'
                }}>
                  <button
                    type="button"
                    onClick={() => setActiveTab('book')}
                    style={{
                      flex: 1,
                      padding: '10px 16px',
                      background: 'none',
                      border: 'none',
                      fontSize: '18px',
                      fontWeight: '500',
                      color: '#000000',
                      cursor: 'pointer',
                      position: 'relative',
                      fontFamily: 'Poppins',
                    }}
                  >
                    Book
                    {activeTab === 'book' && (
                      <div style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: '5px',
                        backgroundColor: '#586B94',
                      }} />
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('profile')}
                    style={{
                      flex: 1,
                      padding: '10px 16px',
                      background: 'none',
                      border: 'none',
                      fontSize: '18px',
                      fontWeight: '500',
                      color: '#000000',
                      cursor: 'pointer',
                      position: 'relative',
                      fontFamily: 'Poppins',
                    }}
                  >
                    Profile
                    {activeTab === 'profile' && (
                      <div style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: '5px',
                        backgroundColor: '#586B94',
                      }} />
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* Content based on active tab */}
            {isICProvider && !isEmpty(availableTimes) ? (
              activeTab === 'book' ? (
                <div className="mt-16">
                  {/* Warning banner if preferred time is unavailable */}
                  {showPreferredUnavailableBanner && (
                    <div className="mb-16" style={{
                      backgroundColor: '#FFFAF0',
                      padding: '16px',
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px'
                    }}>
                      <Warning style={{
                        color: '#000',
                        fontSize: '20px',
                      }} />
                      <div style={{
                        fontSize: '16px',
                        lineHeight: '24px',
                        color: '#000000',
                        fontFamily: 'Poppins',
                      }}>
                        Your preferred time is unavailable, but there are other times within your range.
                      </div>
                    </div>
                  )}
                  
                  {/* Date heading */}
                  <div className="mb-8">
                    <div style={{
                      fontSize: '24px',
                      fontWeight: '500',
                      color: '#000000',
                      fontFamily: 'Poppins',
                      lineHeight: '32px',
                    }}>
                      {get(props, 'booking.cart.date.display', '')}
                    </div>
          </div>
                  
                  {/* Time slots grid */}
                  <div style={{
                    border: '1px solid #E2E2E2',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '16px'
                  }}>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '8px'
                    }}>
                      {map(availableTimes, (timeSlot, idx) => (
                        <button
                          key={`time-slot-${idx}`}
                          type="button"
                          onClick={() => setSelectedTimeSlot(timeSlot)}
                          style={{
                            padding: '8px 0px',
                            borderRadius: '1000px',
                            backgroundColor: selectedTimeSlot === timeSlot ? '#586B94' : '#F1F6FF',
                            color: selectedTimeSlot === timeSlot ? '#FFFFFF' : '#39455E',
                            border: 'none',
                            fontSize: '16px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            textAlign: 'center',
                            fontFamily: 'Poppins',
                            lineHeight: '24px',
                          }}
                        >
                          {timeSlot}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  {AboutSection(bio, expanded, setExpanded)}
                  {ServiceCategories(service_categories)}
                  {ComplimentsSection(compliments)}
                  {ReviewsSection(reviews, isShowMoreClicked, setIsShowMoreClicked)}
                </div>
              )
            ) : (
              <div>
                {AboutSection(bio, expanded, setExpanded)}
                {ServiceCategories(service_categories)}
                {ComplimentsSection(compliments)}
                {ReviewsSection(reviews, isShowMoreClicked, setIsShowMoreClicked)}
                  </div>
                )}
            </div>
          </div>
          {!selectPro ? null : (
            <div className="pro-profile-lower">
              <CTAButton
                additionalWrapperClass="br-top-none-imp"
                disabled={isICProvider && !selected && !isEmpty(availableTimes) && !selectedTimeSlot}
                text={
                  isICProvider
                    ? (selected ? 'Booked' : (selectedTimeSlot ? `Book for ${selectedTimeSlot}` : `Book ${displayName}`))
                    : (selected ? 'Selected' : (hasMoreThanProSelected ? `Add ${displayName} to selected providers` : `Request ${displayName}`))
                }
                action={() => {
                  if (selected) {
                    const timeSlotToPass = !isICProvider ? getPreferredOrClosestTimeForGA() : undefined;
                    unselectPro({ ...pro, timeSlot: timeSlotToPass });
                    showProDetailsToggle();
                  } else if (isICProvider) {
                    if (selectedTimeSlot) {
                      selectPro(pro, selectedTimeSlot);
                      showProDetailsToggle();
                    }
                  } else {
                    const timeSlotToPass = getPreferredOrClosestTimeForGA();
                    selectPro(pro, timeSlotToPass);
                    showProDetailsToggle();
                  }
                }}
              />
            </div>
          )}
        </div>
    );
  }
  return null;
}

const mapStateToProps = (state) => ({
  client: state.client,
  currentChat: state.currentChat,
});
export default connect(mapStateToProps, { fetchChat })(ProProfileDetails);

function AboutSection(about_description, expanded, setExpanded) {
  return (
    <div className="mt-24 mb-32">
      <div className="size-24-32 font-weight-bold contentPrimary mb-10">About</div>
      <div className={`size-14-16 contentSecondary ${expanded ? '' : 'ellipsis-4'}`}>{about_description || ''}</div>
      <br />
      <div
        className="size-14-16 CactusFlowerPrimary cursor-pointer underline"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? 'Read less' : 'Read more'}
      </div>
    </div>
  );
}
function ServiceCategories(service_categories) {
  if (!isEmpty(service_categories)) {
    let mods = [];
    map(service_categories, (service) => {
      mods = concat(mods, service.modalities || []);
    });
    return (
      <div>
        <div className="size-24-32 font-weight-bold contentPrimary mt-24 mb-8">Specialties</div>
        <div className="mb-32">
          <Slider {...{
            dots: false,
            infinite: false,
            slidesToShow: 3.25,
            swipeToSlide: true,
            arrows: false,
          }}
          >
            {map(mods, (md) => (
              <div key={`${md.title}${md.id}`} className="mr-16">
                <div className="mb-8">
                  <img
                    src={get(
                      find(md.images, (e) => (e.kind === 'card_display_image')),
                      'url',
                      '',
                    )}
                    className="w-h-118-130 obj-fit-cover br-rd-8"
                    alt=""
                  />
                </div>
                <div className="size-14-20 contentPrimary">{capitalize(md.title)}</div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}
